import { render, staticRenderFns } from "./DevCardKD4.vue?vue&type=template&id=e41230c8&scoped=true"
import script from "./DevCardKD4.vue?vue&type=script&lang=js"
export * from "./DevCardKD4.vue?vue&type=script&lang=js"
import style0 from "./DevCardKD4.vue?vue&type=style&index=0&id=e41230c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41230c8",
  null
  
)

export default component.exports